"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _InboxMessageHeader = _interopRequireDefault(require("./InboxMessageHeader"));

var _InboxMessageEditor = _interopRequireDefault(require("./InboxMessageEditor"));

var _NavEditbar = _interopRequireDefault(require("../NavEditbar/NavEditbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    width: "100%",
    position: "relative",
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  content: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(2)
  },
  body: {
    maxWidth: "100%",
    overflow: "hidden",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  }
}));

const InboxMessageReply = (_ref) => {
  let author = _ref.author,
      from = _ref.from,
      to = _ref.to,
      message = _ref.message,
      onChange = _ref.onChange,
      buttons = _ref.buttons,
      props = _objectWithoutPropertiesLoose(_ref, ["author", "from", "to", "message", "onChange", "buttons"]);

  const classes = useStyles();
  return _react.default.createElement("article", {
    className: classes.root
  }, _react.default.createElement(_InboxMessageHeader.default, _extends({}, props, {
    from: from,
    replyTo: to,
    author: author
  })), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement(_InboxMessageEditor.default, {
    className: classes.body,
    value: message,
    onChange: onChange
  }), _react.default.createElement(_NavEditbar.default, {
    buttons: buttons
  })));
};

var _default = InboxMessageReply;
exports.default = _default;
module.exports = exports.default;